import { SettingsApi } from '../../services'

const state = {
  isSidebarVisible: false,
  isSidebarEnabled: false,
  inviteModalId: null,
  isInviteModalVisible: false,
  isGettingStartedVideoVisible: false,
  isPaymentModalVisible: false,
  isBannerVisible: true,
  config: null,
  isLoading: false
}

/*
export interface RemoteConfig {
  v: string
  dn: string
  api: string
  pub: string
  app: string
  dm: number
  anon: number
  pt: Pt
  ts: string
}
*/

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setConfig(state, config) {
    state.config = config
  },
  setSidebar(state, isVisible) {
    state.isSidebarVisible = isVisible
  },
  setSidebarEnabled(state, isEnabled) {
    state.isSidebarEnabled = isEnabled
  },
  setInviteModal(state, practiceId) {
    state.inviteModalId = practiceId
  },
  setIsInviteModalVisible(state, isVisible) {
    state.isInviteModalVisible = isVisible
  },
  setIsGettingStartedVideoVisible(state, isVisible) {
    state.isGettingStartedVideoVisible = isVisible
  },
  setIsPaymentModalVisible(state, isVisible) {
    state.isPaymentModalVisible = isVisible ?? !state.isPaymentModalVisible
  },
  setIsBannerVisible(state, isVisible) {
    state.isBannerVisible = isVisible
  }
}

const actions = {
  async load({ commit, state }) {
    if (state.config) return state.config

    commit('setLoading', true)
    let config = null
    try {
      config = await SettingsApi.all({}, { anonymous: true })
      commit('setConfig', config)
    } catch (err) {
      console.error(err)
      commit('setConfig', null)
      throw err
    }
    commit('setLoading', false)
    return config
  },
  setSidebar({ commit, state }, isVisible) {
    commit('setSidebar', isVisible)
  },
  setSidebarEnabled({ commit, state }, isEnabled) {
    commit('setSidebarEnabled', isEnabled)
  },
  toggleSidebar({ commit, state }) {
    commit('setSidebar', !state.isSidebarVisible)
  },
  setInviteModal({ commit }, practiceId) {
    commit('setIsInviteModalVisible', true)
    commit('setInviteModal', practiceId)
  },
  setIsInviteModalVisible({ commit, state }, isVisible) {
    commit('setIsInviteModalVisible', isVisible)
  },
  setIsGettingStartedVideoVisible({ commit, state }, isVisible) {
    commit('setIsGettingStartedVideoVisible', isVisible)
  },
  setIsPaymentModalVisible({ commit, state }, isVisible) {
    commit('setIsPaymentModalVisible', isVisible ?? !state.isPaymentModalVisible)
  },
  setIsBannerVisible({ commit, state }, isVisible) {
    commit('setIsBannerVisible', isVisible)
  }
}

const getters = {
  PracticeTypes(state) {
    return Object.keys(state.config.pt)
  },
  WithReasons(state) {
    const withReasons = {}
    for (const practiceType in state.config.pt) {
      withReasons[practiceType] = state.config.pt[practiceType].reasons
    }
    return withReasons
  },
  FlatReasons: (state, getters) =>
    Object.keys(getters.WithReasons).reduce((a, c) => ({ ...a, ...getters.WithReasons[c] }), {}),

  PracticeDataArray: state =>
    Object.entries(state.config.pt).map(([name, { plural, abbr, reasons }]) => ({
      name: name,
      plural,
      abbr,
      reasons
    })),

  PracticeTypesPlural(state, getters) {
    return getters.PracticeDataArray.map(({ plural }) => plural)
  },
  PracticeTypesAbbr(state) {
    return Object.values(state.config.pt).map(({ abbr }) => abbr)
  },
  DemoId: state => state.config.dm,
  AnonId: state => state.config.anon
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
